// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IngestionSpecListItem
 */
export interface IngestionSpecListItem {
    /**
     * 
     * @type {Date}
     * @memberof IngestionSpecListItem
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof IngestionSpecListItem
     */
    domain: string;
    /**
     * 
     * @type {Date}
     * @memberof IngestionSpecListItem
     */
    lastModifiedAt: Date;
    /**
     * Map structure representing JSON data
     * @type {{ [key: string]: any; }}
     * @memberof IngestionSpecListItem
     */
    spec: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof IngestionSpecListItem
     */
    specId: string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSpecListItem
     */
    studyId: string;
}

/**
 * Check if a given object implements the IngestionSpecListItem interface.
 */
export function instanceOfIngestionSpecListItem(value: object): value is IngestionSpecListItem {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('spec' in value) || value['spec'] === undefined) return false;
    if (!('specId' in value) || value['specId'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function IngestionSpecListItemFromJSON(json: any): IngestionSpecListItem {
    return IngestionSpecListItemFromJSONTyped(json, false);
}

export function IngestionSpecListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IngestionSpecListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'domain': json['domain'],
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'spec': json['spec'],
        'specId': json['specId'],
        'studyId': json['studyId'],
    };
}

export function IngestionSpecListItemToJSON(json: any): IngestionSpecListItem {
    return IngestionSpecListItemToJSONTyped(json, false);
}

export function IngestionSpecListItemToJSONTyped(value?: IngestionSpecListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'domain': value['domain'],
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'spec': value['spec'],
        'specId': value['specId'],
        'studyId': value['studyId'],
    };
}
